import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createRefund } from './refundService';
import RefundVoucher from './RefundVoucher';

const RefundForm = ({ onRefundCreated }) => {
  const navigate = useNavigate();
  const [saleId, setSaleId] = useState('');
  const [saleItemId, setSaleItemId] = useState('');
  const [refundDate, setRefundDate] = useState('');
  const [totalRefund, setTotalRefund] = useState('');
  const [supplierFee, setSupplierFee] = useState('');
  const [customerFee, setCustomerFee] = useState('');
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [voucherData, setVoucherData] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!saleId || !saleItemId || !totalRefund || !refundDate) {
      alert('Sale ID, Sale Item ID, Total Refund, and Refund Date are required.');
      return;
    }

    try {
      setLoading(true);

      const refundData = {
        refund_date: refundDate,
        total_refund: Number(totalRefund),
        notes,
        status: 'COMPLETED',
        items: [
          {
            sale_item_id: Number(saleItemId),
            refund_amount: Number(totalRefund),
            supplier_cancellation_fee: Number(supplierFee || 0),
            customer_cancellation_fee: Number(customerFee || 0),
          },
        ],
      };

      const result = await createRefund(Number(saleId), refundData);

      console.log("Refund result from backend:", result);

      onRefundCreated?.(result);

      // ✅ Pass backend response directly to voucher
      setVoucherData(result);

      alert('Refund created successfully!');

      // Reset form
      setSaleId('');
      setSaleItemId('');
      setRefundDate('');
      setTotalRefund('');
      setSupplierFee('');
      setCustomerFee('');
      setNotes('');
    } catch (error) {
      console.error('Refund error:', error);
      alert(error.response?.data?.detail || 'Error creating refund');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 p-3 border-bottom">
        <h4 className="mb-0">Create Sales Refund</h4>
        <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>
      <form onSubmit={handleSubmit} className="p-3 border rounded">
        <div className="mb-2">
          <label>Sale ID</label>
          <input
            type="number"
            className="form-control"
            value={saleId}
            onChange={(e) => setSaleId(e.target.value)}
            required
          />
        </div>

        <div className="mb-2">
          <label>Sale Item ID</label>
          <input
            type="number"
            className="form-control"
            value={saleItemId}
            onChange={(e) => setSaleItemId(e.target.value)}
            required
          />
        </div>

        <div className="mb-2">
          <label>Refund Date</label>
          <input
            type="date"
            className="form-control"
            value={refundDate}
            onChange={(e) => setRefundDate(e.target.value)}
            required
          />
        </div>

        <div className="mb-2">
          <label>Total Refund</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={totalRefund}
            onChange={(e) => setTotalRefund(e.target.value)}
            required
          />
        </div>

        <div className="mb-2">
          <label>Supplier Cancellation Fee</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={supplierFee}
            onChange={(e) => setSupplierFee(e.target.value)}
          />
        </div>

        <div className="mb-2">
          <label>Customer Cancellation Fee</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={customerFee}
            onChange={(e) => setCustomerFee(e.target.value)}
          />
        </div>

        <div className="mb-2">
          <label>Notes</label>
          <textarea
            className="form-control"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Creating...' : 'Create Refund'}
        </button>
      </form>

      {/* ✅ Pass backend object directly */}
      {voucherData && <RefundVoucher data={voucherData} />}
    </>
  );
};

export default RefundForm;
